
        document.addEventListener('DOMContentLoaded', function () {
            const videoPlayer = document.querySelector('.video-player');
            const thumbnail = videoPlayer.querySelector('.video-thumbnail');
            const video = videoPlayer.querySelector('.video-content');
            const playButton = videoPlayer.querySelector('.play-button');
            const infoBar = videoPlayer.querySelector('.video-info-bar');

            playButton.addEventListener('click', function (e) {
                e.stopPropagation();
                playVideo();
            });

            videoPlayer.addEventListener('click', function () {
                if (video.paused) {
                    playVideo();
                } else {
                    pauseVideo();
                }
            });

            function playVideo() {
                thumbnail.style.opacity = '0';
                video.style.display = 'block';

                video.setAttribute('controls', 'controls');

                playButton.style.display = 'none';

                infoBar.style.opacity = '0';

                video.play();
            }

            function pauseVideo() {
                video.pause();

                video.removeAttribute('controls');

                playButton.style.display = 'flex';

                infoBar.style.opacity = '1';
            }

            video.addEventListener('ended', function () {
                video.style.display = 'none';
                thumbnail.style.opacity = '0.9';

                video.removeAttribute('controls');

                playButton.style.display = 'flex';

                infoBar.style.opacity = '1';
            });

            video.addEventListener('pause', function () {
                if (video.currentTime < video.duration) {
                    pauseVideo();
                }
            });
        });

        document.addEventListener('DOMContentLoaded', function () {
            const productContainers = document.querySelectorAll('.products-container');

            productContainers.forEach(container => {
                updateScrollButtons(container);

                container.addEventListener('scroll', function () {
                    updateScrollButtons(this);
                });
            });

            const scrollButtons = document.querySelectorAll('.scroll-btn');
            scrollButtons.forEach(button => {
                button.addEventListener('click', function () {
                    if (this.classList.contains('disabled')) return;

                    const container = this.parentElement.querySelector('.products-container');
                    const scrollAmount = 300; 

                    if (this.classList.contains('left')) {
                        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                    } else {
                        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                    }

                    setTimeout(() => {
                        updateScrollButtons(container);
                    }, 300);
                });
            });

            function updateScrollButtons(container) {
                const leftBtn = container.parentElement.querySelector('.scroll-btn.left');
                const rightBtn = container.parentElement.querySelector('.scroll-btn.right');

                const isScrollable = container.scrollWidth > container.clientWidth;

                if (!isScrollable) {
                    leftBtn.classList.add('hidden');
                    rightBtn.classList.add('hidden');
                    return;
                } else {
                    leftBtn.classList.remove('hidden');
                    rightBtn.classList.remove('hidden');
                }

                const isAtStart = container.scrollLeft === 0;
                const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1; 

                if (isAtStart) {
                    leftBtn.classList.add('disabled');
                    rightBtn.classList.remove('disabled');
                } else if (isAtEnd) {
                    leftBtn.classList.remove('disabled');
                    rightBtn.classList.add('disabled');
                } else {
                    leftBtn.classList.remove('disabled');
                    rightBtn.classList.remove('disabled');
                }
            }

            window.addEventListener('resize', function () {
                productContainers.forEach(container => {
                    updateScrollButtons(container);
                });
            });

            window.addEventListener('load', function () {
                productContainers.forEach(container => {
                    updateScrollButtons(container);
                });
            });
        });
